<div class="content_wrapper">
    <app-summary></app-summary>
</div>
